import styled from '@emotion/styled';
import PerfectScrollbar from 'react-perfect-scrollbar';

import Typography from '../../atoms/typography';

export const Heading = styled(Typography)(({ theme }) => ({
  color: theme.color.brand,
  display: 'flex',
  fontSize: theme.modularScale.sixteen,
  letterSpacing: '0.2rem',
  lineHeight: '5rem',
  textTransform: 'uppercase',
  '> span': {
    color: theme.color.brandLightBlue,
    letterSpacing: 'initial',
    marginLeft: 'auto',
    textTransform: 'none'
  },
  [`@media screen and (min-width: ${theme.breakpoint.medium})`]: {
    fontSize: theme.modularScale.fourteen
  }
}));

export const Accordion = styled.section(({ theme }) => ({
  borderBottomWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.color.borderBlueLight,
  ':first-of-type': { marginTop: '1.6rem' },
  [`@media screen and (min-width: ${theme.breakpoint.medium})`]: {
    ':first-of-type': { marginTop: 0 }
  }
}));

export const AccordionTrigger = styled.button`
  appearance: none;
  ${(props) => props.theme.arrow(props.isOpened ? 'up' : 'down', props.theme.color.brand, 'right 1px center', 4)}
  background-color: transparent;
  border: 0 none;
  color: ${(props) => props.theme.color.brand};
  cursor: pointer;
  display: block;
  font-family: ${(props) => props.theme.font.sans};
  font-size: ${(props) => props.theme.modularScale.sixteen};
  line-height: 5rem;
  outline: none;
  padding: 0;
  position: relative;
  text-align: left;
  text-transform: capitalize;
  width: 100%;
`;

export const AccordionPanel = styled.div(({ active }) => ({
  display: active ? 'block' : 'none'
}));

export const List = styled(PerfectScrollbar)(({ showMore }) => ({
  position: 'relative',
  maxHeight: showMore ? '28rem' : 'auto',
  a: { textDecoration: 'none' }
}));
